export const tsOfficePhone = '(386) 382-4200'
export const tsOfficeFax = '(386) 382-4201'
// Legacy (CureMD) patient payment page, for balances that still live there.
export const cureMdPaymentUrl =
  'https://lib.mycurecloud.com/webPaymentsClient/?token=hFsySvDuXw4gDtQxqMF0rI1mEh8eHyff1o1HgtJx1sQ%3D'
